import { css } from '@microsoft/fast-element';
import { getToken } from '../../design-tokens';
import { baseRadioStyles } from '../../styles/patterns/radio';
import { heightNumber } from '../../styles/size';
import { display } from '../../foundation/display';

export const radioStyles = css`
    ${display("inline-flex")} :host {
        --input-size: calc((${heightNumber} / 2) + (${getToken('space-stroke-width')} * 2));
        align-items: center;
        outline: none;
        user-select: none;
        position: relative;
        flex-direction: row;
        transition: all 0.2s ease-in-out;
    }

    ${baseRadioStyles}
`;
